import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatDividerModule} from '@angular/material/divider';
import {MatIconModule} from '@angular/material/icon';
import {MatStepperModule} from '@angular/material/stepper';
import { AppRoutingModule } from './app-routing.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PagenotfoundComponent } from './pagenotfound/pagenotfound.component';
import {StaticContentComponent} from './static-content/static-content.component';
import {StaticContentService} from './service/satic-content-service/static-content.service';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import {MatGridListModule} from '@angular/material/grid-list';
import { BlockUIModule } from 'ng-block-ui';
import { CookieModule, CookieService } from 'ngx-cookie';
import {MatInputModule} from '@angular/material/input'
import {MatCardModule} from '@angular/material/card';
import {MatButtonModule} from '@angular/material/button';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatRadioModule} from '@angular/material/radio';

import { LTIComponent } from './lti/lti.component';
import { BlockUIService } from './service/block-ui-service/blockui.service';
import { CommonService } from './service/common-service/common.service';
import { BodyBlock } from './shared/body-block';
import { HeaderInterceptor } from './service/header-interceptor/headerInterceptor';
import { SafePipe } from './pipes/safe pipe/safe.pipe';
import { SanitizePipe } from './pipes/sanitize pipe/sanitize.pipe';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';

@NgModule({ declarations: [
        AppComponent,
        PagenotfoundComponent,
        StaticContentComponent,
        ConfirmDialogComponent,
        LTIComponent,
        SafePipe,
        SanitizePipe,
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [BrowserModule,
        AppRoutingModule,
        MatStepperModule,
        MatExpansionModule, MatInputModule, MatCardModule, MatButtonModule, MatDividerModule, BrowserAnimationsModule,
        MatDialogModule, MatFormFieldModule, MatProgressSpinnerModule, MatProgressBarModule,
        MatIconModule, MatRadioModule,
        FormsModule,
        MatGridListModule,
        BlockUIModule.forRoot({ delayStart: 500, delayStop: 500 }),
        CookieModule.forRoot()], providers: [StaticContentService, DatePipe, BlockUIService, CookieService, CommonService, BodyBlock,
        { provide: HTTP_INTERCEPTORS, useClass: HeaderInterceptor, multi: true }, provideHttpClient(withInterceptorsFromDi())] })
export class AppModule { }
